<template>
  <div id="app">
    <router-view />
    <qr-login-modal
      :visible="loginModalVisible"
      :redirect="loginRedirect"
      @close="closeLogin"
      @success="onLoginSuccess"
    />
    <payment-qr-modal
      :visible="paymentModal.visible"
      :qr-url="paymentModal.qrUrl"
      :order-no="paymentModal.orderNo"
      :pay-amount="paymentModal.payAmount"
      @close="closePayment"
      @check="checkPayment"
      @later="payLater"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import QrLoginModal from '@/components/auth/QrLoginModal.vue'
import PaymentQrModal from '@/components/order/PaymentQrModal.vue'
import { checkPayStatus } from '@/api/order'
import { ORDER_STATUS, PAY_POLL_INTERVAL_MS } from '@/constants/auth'

export default {
  name: 'App',
  components: {
    QrLoginModal,
    PaymentQrModal
  },
  data() {
    return {
      payTimer: null
    }
  },
  computed: {
    ...mapState(['loginModalVisible', 'loginRedirect', 'paymentModal'])
  },
  watch: {
    'paymentModal.visible'(visible) {
      if (visible) {
        this.startPayPolling()
      } else {
        this.stopPayPolling()
      }
    }
  },
  beforeDestroy() {
    this.stopPayPolling()
  },
  methods: {
    closeLogin() {
      this.$store.commit('HIDE_LOGIN')
    },
    onLoginSuccess(payload) {
      this.$store.dispatch('loginSuccess', {
        token: payload.token,
        user: payload.user,
        redirect: this.loginRedirect,
        router: this.$router
      })
    },
    closePayment() {
      this.$store.commit('HIDE_PAYMENT')
    },
    payLater() {
      this.stopPayPolling()
      this.$store.commit('HIDE_PAYMENT')
      this.$router.push('/my-orders').catch(() => {})
    },
    startPayPolling() {
      this.stopPayPolling()
      this.payTimer = setInterval(() => {
        this.checkPayment(false)
      }, PAY_POLL_INTERVAL_MS)
    },
    stopPayPolling() {
      if (this.payTimer) {
        clearInterval(this.payTimer)
        this.payTimer = null
      }
    },
    checkPayment(isManual = true) {
      const { orderNo, orderStatus } = this.paymentModal
      if (!orderNo) return

      checkPayStatus(orderNo)
        .then(result => {
          if (result.status !== 1 || !result.data) {
            if (isManual) window.alert('暂未查询到支付结果，请稍后重试')
            return
          }
          if (result.data.status !== orderStatus) {
            this.stopPayPolling()
            this.$store.commit('HIDE_PAYMENT')
            if (result.data.status !== ORDER_STATUS.CANCELLED) {
              window.alert('支付成功')
            }
            if (this.$route.path === '/my-orders') {
              this.$router.replace('/my-orders')
            } else {
              this.$router.push('/my-orders')
            }
            return
          }
          if (isManual) {
            window.alert('暂未查询到支付结果，请稍后重试或确认是否已扣款')
          }
        })
        .catch(() => {
          if (isManual) window.alert('查询支付状态失败，请稍后重试')
        })
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
